import React from 'react';
import { ToggleButtonGroup, ToggleButton } from '@mui/material';
import { ViewModule, TableChart } from '@mui/icons-material';

interface TravellerViewModeToggleProps {
    viewMode: 'grid' | 'table';
    onViewModeChange: (mode: 'grid' | 'table') => void;
}

const TravellerViewModeToggle: React.FC<TravellerViewModeToggleProps> = ({
    viewMode,
    onViewModeChange
}) => {
    return (
        <ToggleButtonGroup
            value={viewMode}
            exclusive
            onChange={(_, newMode) => newMode && onViewModeChange(newMode)}
            size="small"
        >
            <ToggleButton value="grid" sx={{ px: 2 }}>
                <ViewModule sx={{ fontSize: 24 }} />
            </ToggleButton>
            <ToggleButton value="table" sx={{ px: 2 }}>
                <TableChart sx={{ fontSize: 24 }} />
            </ToggleButton>
        </ToggleButtonGroup>
    );
};

export default TravellerViewModeToggle;
